const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",
  CAT_TREE_LIST: "CAT_TREE_LIST",
  CAT_TREE_LIST_RESULT: "CAT_TREE_LIST_RESULT",
  // CAT_LEAF_ADD: "CAT_LEAF_ADD",

  // leafCatAdd: (history, dataObj) => ({
  //   //Action creator function
  //   type: actions.CAT_LEAF_ADD, //Action
  //   payload: { history, dataObj }, //pass payload to action, we should pass as little data to action
  // }),

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  CatTreeRead: (info) => ({
    type: actions.CAT_TREE_LIST,
    payload: { info },
  }),

  catTreeListSuccess: (exportresult, result, success, total_count) => ({
    type: actions.CAT_TREE_LIST_RESULT,
    exportresult,
    result,
    success,
    total_count,
  }),
};
export default actions;
